import React from 'react';
import { Skeleton, Button, Box } from '@mui/material';

export function DefaultAmountOptionsSkeleton() {
	return (    
		<Box className="AmountOptions">
			{[...Array(6)].map((value, index) => {
				return (
						<Button
							key={index}
							id="customAmount"
							name="donationAmount"
							className="default-amount-card"
							variant="outlined"
							sx={{
								borderColor: '#C8C8C8',
								color: '#495057',
								width: '100%',
							}}
							fullWidth
							disabled
						>
							<Skeleton width={40} />
						</Button>
				);
			})}
		</Box>
	);
}
